import React from "react";
import PropTypes from "prop-types";
import Copy from "@nib-components/copy";
import { Stack } from "@nib/layout";
import { LessonWithAccordion, LessonWithoutAccordion } from "../LessonList";
import Accordion from "@nib-components/accordion";

const CourseItem = ({ modules, title, isMobile }) => {
  return Array.isArray(modules) && modules.length ? (
    <Stack space={{ xs: 2, md: 4 }}>
      <Accordion>
        {modules.map((module, index) =>
          module.lessons.length ? (
            <Accordion.Item key={index} title={`Module ${index + 1}`} subtitle={module.name}>
              <LessonWithAccordion
                name={module.name}
                title={title}
                lessons={module.lessons}
                lessonNumber={index + 1}
                isMobile={isMobile}
              />
            </Accordion.Item>
          ) : (
            <LessonWithoutAccordion
              key={index}
              name={module.name}
              title={title}
              lessonNumber={index + 1}
            />
          )
        )}
      </Accordion>
    </Stack>
  ) : (
    // TODO refactor to return nothing here
    <Copy></Copy>
  );
};

CourseItem.propTypes = {
  modules: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      previewLink: PropTypes.string,
      lessons: PropTypes.array,
    })
  ),
  title: PropTypes.string,
  isMobile: PropTypes.bool,
};
export default CourseItem;
